import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a2e15c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "support" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Support", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please select your issue below. If you cannot find your issue, contact us.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Account problems", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://forums.themanaworld.org/viewtopic.php?f=20&t=7559" }, "My account is banned")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://forums.themanaworld.org/viewtopic.php?f=20&t=6472" }, "My account was compromised")
], -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h1 id=\"contact\" data-v-59a2e15c>Contact us</h1><p data-v-59a2e15c>On IRC: <a href=\"https://web.libera.chat/?channels=#themanaworld\" target=\"_blank\" rel=\"noopener nofollow\" data-v-59a2e15c>#themanaworld on Libera Chat</a></p><p data-v-59a2e15c>On Discord: <a href=\"https://discord.com/invite/UnY77dR\" target=\"_blank\" rel=\"noopener nofollow\" data-v-59a2e15c>The Mana World server</a></p><p data-v-59a2e15c>On Matrix: <a href=\"https://matrix.to/#/#tmw:matrix.org\" target=\"_blank\" rel=\"noopener nofollow\" data-v-59a2e15c>TMW Matrix server</a></p><p data-v-59a2e15c>On the forums: <a href=\"https://forums.themanaworld.org/viewforum.php?f=3\" data-v-59a2e15c>Support and Bug reports</a></p><h1 data-v-59a2e15c>Technical contacts</h1>", 6)
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("address", null, "legal@themanaworld.org", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("address", null, "legal@themanaworld.org", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("address", null, "data@themanaworld.org", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"smaller"} }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createTextVNode("The Mana World does "),
    /*#__PURE__*/_createElementVNode("b", null, "not"),
    /*#__PURE__*/_createTextVNode(" provide legal advise.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/recover/password" }, {
          default: _withCtx(() => [
            _createTextVNode("I forgot my password")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/recover/username" }, {
          default: _withCtx(() => [
            _createTextVNode("I forgot my user name")
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _hoisted_6
    ]),
    _hoisted_7,
    _createTextVNode(" Legal inquiries: "),
    _hoisted_13,
    _createTextVNode(" DMCA takedown requests: "),
    _hoisted_14,
    _createTextVNode(" GDPR requests: "),
    _hoisted_15,
    _createTextVNode(" Security disclosures: "),
    _createElementVNode("address", null, [
      _createTextVNode(" security@themanaworld.org "),
      (_ctx.PGP)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
            _createTextVNode("(PGP: "),
            _createElementVNode("a", {
              href: `http://pgp.mit.edu/pks/lookup?op=get&search=${_ctx.PGP}`,
              rel: "noopener"
            }, _toDisplayString(_ctx.PGP), 9, _hoisted_17),
            _createTextVNode(")")
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_18,
    _hoisted_19
  ]))
}